import * as types from './types';

export const initializeSuccess = () => ({ type: types.INITIALIZE_SUCCESS });

export const changeLocation = ({ location }) => ({
  type: types.LOCATION_CHANGE,
  payload: { location },
});

export const page = {
  request: ({ location }) => ({
    type: types.PAGE_REQUEST,
    payload: { location },
  }),
  success: ({ model }) => ({
    type: types.PAGE_SUCCESS,
    payload: { model },
  }),
  error: ({ error }) => ({
    type: types.PAGE_ERROR,
    payload: error,
  }),
};

export const setIsLoaded = ({ isLoaded }) => ({
  //isLoaded
  type: types.SET_IS_LOADED,
  payload: { isLoaded },
});

export const setIsFetching = ({ isFetching }) => ({
  type: types.SET_IS_FETCHING,
  payload: { isFetching },
});

export const setDidSessionExpire = ({ didSessionExpire }) => ({
  type: types.USER_SESSION_EXPIRED,
  payload: { didSessionExpire },
});

export const pagePending = {
  start: () => ({
    type: types.PAGE_PENDING_START,
  }),
  finish: () => ({
    type: types.PAGE_PENDING_FINISH,
  }),
};
